/* ============================================
   APLOM HF - Behaviors
   Scroll-reveal · Counter animation · Parallax · Sticky cart · Burger menu
   ============================================ */

(function() {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================
     1. SCROLL REVEAL - fade + translate quand section entre dans viewport
     ============================================ */
  if (!reducedMotion) {
    var revealSelectors = '.aplom-reveal, section.shopify-section, .aplom-section-immersive, .aplom-section-bleu-clair, .aplom-pictos-band, .aplom-reassurance-4cols';
    var revealEls = document.querySelectorAll(revealSelectors);
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('aplom-reveal', 'is-visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    revealEls.forEach(function(el) { revealObs.observe(el); });
  }

/* === aplom · compteurs count-up (unifié : lit data-target, sinon data-counter)
   V2 03/06/2026 : le HTML serveur garde les valeurs finales (SEO/GEO),
   la remise à 0 se fait au démarrage de l'animation, plus au chargement. === */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function val(el) {
    var raw = (el.getAttribute('data-target') || el.getAttribute('data-counter') || '').trim();
    var target = parseFloat(raw);
    return {
      ok: !isNaN(target),
      target: target,
      decimals: (raw.split('.')[1] || '').length,   // gère 1.4, -64, 800…
      prefix: el.getAttribute('data-prefix') || '',
      suffix: el.getAttribute('data-suffix') || ''
    };
  }

  function run(el) {
    if (el.dataset.counted) return;                  // anti double-exécution
    var c = val(el);
    if (!c.ok) return;
    el.dataset.counted = '1';
    if (reduce) { el.textContent = c.prefix + c.target.toFixed(c.decimals) + c.suffix; return; }
    el.textContent = c.prefix + (0).toFixed(c.decimals) + c.suffix; // remise à 0 juste avant d'animer
    var dur = 1600, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);            // easeOutCubic
      el.textContent = c.prefix + (c.target * eased).toFixed(c.decimals) + c.suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = c.prefix + c.target.toFixed(c.decimals) + c.suffix;
    }
    requestAnimationFrame(step);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
    });
  }, { threshold: 0.4 });

  document.querySelectorAll('[data-counter]').forEach(function (el) {
    io.observe(el); // le HTML serveur affiche la valeur finale jusqu'au scroll
  });
})();

  /* ============================================
     3. PARALLAX LÉGER - photos full-bleed défilent à 0.85x du scroll
     Usage HTML : <div data-parallax><img ...></div>
     ============================================ */
  if (!reducedMotion) {
    var parallaxEls = document.querySelectorAll('[data-parallax]');
    if (parallaxEls.length) {
      var ticking = false;
      function updateParallax() {
        parallaxEls.forEach(function(el) {
          var rect = el.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          var img = el.querySelector('img');
          if (!img) return;
          var offset = (rect.top - window.innerHeight / 2) * 0.15;
          img.style.transform = 'translateY(' + offset + 'px) scale(1.08)';
        });
        ticking = false;
      }
      window.addEventListener('scroll', function() {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }, { passive: true });
    }
  }

  /* ============================================
     4. STICKY CART BAR - apparaît après scroll passé le hero
     Place <div class="aplom-sticky-cart" data-sticky-cart>...</div> dans le template produit
     Le hero doit être identifié par .aplom-product-hero, #hero, ou .product-hero
     ============================================ */
  var stickyCart = document.querySelector('[data-sticky-cart]');
  if (stickyCart) {
    var hero = document.querySelector('.aplom-product-hero, #hero, .product-hero');
    if (hero) {
      var cartObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (!e.isIntersecting && e.boundingClientRect.top < 0) {
            stickyCart.classList.add('is-visible');
          } else if (e.isIntersecting) {
            stickyCart.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });
      cartObs.observe(hero);
    } else {
      // Fallback : afficher après 600px de scroll
      window.addEventListener('scroll', function() {
        if (window.scrollY > 600) {
          stickyCart.classList.add('is-visible');
        } else {
          stickyCart.classList.remove('is-visible');
        }
      }, { passive: true });
    }
  }

  /* ============================================
     5. BURGER MENU MOBILE - toggle drawer
     Place <button class="aplom-burger">☰</button> dans header
     Et <aside class="aplom-drawer">...</aside> à côté
     ============================================ */
  var burger = document.querySelector('.aplom-burger');
  var drawer = document.querySelector('.aplom-drawer');
  if (burger && drawer) {
    burger.addEventListener('click', function() {
      drawer.classList.toggle('is-open');
    });
    // Fermer drawer si clic en dehors
    document.addEventListener('click', function(e) {
      if (drawer.classList.contains('is-open') &&
          !drawer.contains(e.target) &&
          !burger.contains(e.target)) {
        drawer.classList.remove('is-open');
      }
    });
    // Fermer drawer sur touche Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
      }
    });
  }

  /* ============================================
     6. FAQ ACCORDION - smooth open/close (au cas où le thème ne le gère pas)
     Usage HTML : <details><summary>Q</summary><div>R</div></details>
     ============================================ */
  document.querySelectorAll('details').forEach(function(d) {
    d.addEventListener('toggle', function() {
      // Optionnel : log analytics ouverture FAQ
      if (d.open && window.gtag) {
        gtag('event', 'faq_open', { question: d.querySelector('summary')?.textContent?.slice(0, 50) });
      }
    });
  });

})();

/* === aplom · scroll reveal sur [data-reveal] === */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('aplom-anim');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  var foldLine = window.innerHeight * 0.92;
  document.querySelectorAll('[data-reveal]').forEach(function (el) {
    if (el.getBoundingClientRect().top < foldLine) {
      // Déjà dans le 1er écran : on l'affiche sans animer (protège le hero/LCP)
      el.classList.add('aplom-reveal-armed', 'is-visible');
    } else {
      el.classList.add('aplom-reveal-armed');
      // Léger stagger entre frères qui se révèlent ensemble (cards, grilles)
      var sibs = el.parentElement
        ? el.parentElement.querySelectorAll(':scope > [data-reveal]') : [];
      var idx = Array.prototype.indexOf.call(sibs, el);
      if (idx > 0) el.style.transitionDelay = Math.min(idx * 70, 280) + 'ms';
      io.observe(el);
    }
  });
})();